import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingFlatTourBookingContainer } from '../NewbuildingFlatTourBooking';
import { NewbuildingHeaderCallContainer } from '../NewbuildingHeaderCall';
import { NewbuildingHeaderChatButtonContainer } from '../NewbuildingHeaderChatButton';
import { NewbuildingHeaderCompareButton } from '../NewbuildingHeaderCompareButton';
import { COMPARE_ENABLED_CONFIG } from '../NewbuildingHeaderCompareButton/constants';
import { NewbuildingHeaderFavouriteButtonContainer } from '../NewbuildingHeaderFavouriteButton';
import { HeartFavouriteButton } from 'shared/components/HeartFavouriteButton';
import { NewbuildingHeaderServices } from 'shared/components/NewbuildingHeaderServices';
import { getBuilderChatEnabled } from 'shared/selectors/newbuildingHeader';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const NewbuildingHeaderServicesContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const isBuilderChatEnabled = useSelector(getBuilderChatEnabled);
  const isCompareEnabled = config.get<boolean>(COMPARE_ENABLED_CONFIG) || false;

  return (
    <NewbuildingHeaderServices>
      <NewbuildingHeaderCallContainer />
      {isBuilderChatEnabled && <NewbuildingHeaderChatButtonContainer />}
      {!isCompareEnabled && <NewbuildingFlatTourBookingContainer isShortened={isBuilderChatEnabled} />}
      <NewbuildingHeaderCompareButton withOnboarding={true} />
      <NewbuildingHeaderFavouriteButtonContainer button={HeartFavouriteButton} />
    </NewbuildingHeaderServices>
  );
};
